<template>
  <div class="modal fade" id="addFixedPayment" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-10 my-auto">
                <h5 class="modal-title" id="addFixedPaymentLabel">Add Direct Debit</h5>
              </div>
              <div class="col-2 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x"
                          data-dismiss="modal"
                          id="closeAddFixedPayment"
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <form @submit.prevent="addFixedPayment()">
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-sm-12">
                      <p class="font-weight-bold">Regular Payment:</p>
                      <div class="input-group-prefix prefix w-100">
                        <span class="input-group-addon">£</span>
                        <input
                          type="number"
                          step=".01"
                          class="z-depth-1 prefix"
                          id="regularPaymentInput"
                          v-model="regularAmount"
                          placeholder="Eg: 10.00"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <span class="d-inline">
                        <label class="checkbox">
                          <input
                            v-b-toggle.initialPaymentSection
                            type="checkbox"
                            v-model="hasInitialAmount"
                          />
                          <span class="default"></span>
                        </label>
                      </span>
                      <p class="d-inline ml-2">Different initial payment amount.</p>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-sm-12">
                      <b-collapse id="initialPaymentSection">
                        <p class="font-weight-bold">Initial Payment:</p>
                        <div class="input-group-prefix prefix w-100">
                          <span class="input-group-addon">£</span>
                          <input
                            type="number"
                            step=".01"
                            class="z-depth-1 prefix"
                            id="initialPaymentInput"
                            v-model="initalAmount"
                            placeholder="Eg: 10.00"
                          />
                        </div>
                      </b-collapse>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-lg-12 mt-2 mt-lg-0">
                      <el-date-picker
                        placeholder="First Collection"
                        v-model="firstCollection"
                        format="dd.MM.yyyy"
                        value-format="yyyy-MM-dd"
                        type="date"
                        @change="checkBacsCalendar()"
                        :picker-options="firstCollectionOptions"
                      />
                    </div>
                  </div>
                  <div v-if="displayEffectiveTo" class="row mt-4">
                    <div class="col-lg-12 mt-2 mt-lg-0">
                      <el-date-picker
                        placeholder="Effective To"
                        v-model="effectiveTo"
                        format="dd.MM.yyyy"
                        value-format="yyyy-MM-dd"
                        type="date"
                        :picker-options="effectiveToOptions"
                      />
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-lg-12">
                      <multiselect
                        v-model="collectionDays"
                        :options="daysOfMonth()"
                        open-direction="top"
                        :maxHeight="240"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Collection day(s)"
                      >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                          <span class="multiselect__single" v-if="values.length && !isOpen">
                            {{ values.length }} {{ values.length > 1 ? 'days' : 'day' }} selected
                          </span>
                        </template>
                      </multiselect>
                    </div>
                    <!-- <div class="col-sm-6" v-if="collectionDays.length > 0">
                      <p class="font-weight-bold">Next Collection Date:</p>
                      <p>{{nextCollectionDate | moment('Do MMM YYYY')}}</p>
                    </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-hc float-right"
              :disabled="submitStatus === 'PENDING'"
            >Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { uuid } from 'vue-uuid';

export default {
	data() {
		return {
			submitStatus: null,
			regularAmount: null,
			hasInitialAmount: false,
			initalAmount: null,
			firstCollection: null,
			effectiveTo: null,
			collectionDays: [],
			firstCollectionOptions: {
				disabledDate: (date) => {
					return (
						date >= moment(this.effectiveTo) || date < moment().add(6, 'days')
					);
				},
			},
			effectiveToOptions: {
				disabledDate: (date) => {
					return date <= moment(this.firstCollection);
				},
			},
		};
	},
	validations: {},
	computed: {
		account() {
			return this.$store.state.customers.account;
		},
		bacsCalendar() {
			return this.$store.state.finances.bacsCalendar;
		},
		nextCollectionDate() {
			if (this.bacsCalendar) {
				if (this.bacsCalendar.BacsDay) {
					return this.bacsCalendar.RequestedDate;
				}
				return this.bacsCalendar.NextBacsDay;
			}
			return null;
		},
		fixedPayments() {
			return this.$store.state.finances.fixedPayments;
		},
		currentFixedPayment() {
			return this.$_.find(
				this.$_.sortBy(this.fixedPayments, 'FirstCollectionDue').reverse(),
				function(fp) {
					return (
						!fp.hasOwnProperty('EffectiveTo') ||
						moment(moment().format('YYYY-MM-DD')).isSameOrBefore(
							moment.utc(fp.EffectiveTo).format()
						)
					);
				}
			);
		},
		displayEffectiveTo() {
			return !['DUAL', 'SEBL'].includes(this.$config.honeycomb.supplierId);
		},
	},
	methods: {
		async addFixedPayment() {
			if (!this.regularAmount || this.regularAmount <= 0) {
				this.$snotify.warning(
					'Warning! Please enter a regular payment amount.'
				);
			}
			if (!this.firstCollection) {
				this.$snotify.warning(
					'Warning! Please select a first collection date.'
				);
			}
			if (this.collectionDays.length == 0) {
				this.$snotify.warning(
					'Warning! Please select at least one collection day.'
				);
			}
			if (
				this.regularAmount > 0 &&
				this.firstCollection &&
				this.collectionDays.length > 0
			) {
				this.submitStatus = 'PENDING';
				this.$http
					.post(
						'https://' +
							this.$config.honeycomb.ddbot.domain +
							'/api/v1/fixed-payments',
						{
							Id: uuid.v1(),
							AccountId: this.account.Id,
							DaysOfMonth: this.collectionDays.sort((a, b) => a - b),
							FirstCollectionDue: moment.utc(this.nextCollectionDate).format(),
							FirstCollectionAmount: this.hasInitialAmount
								? parseFloat(this.initalAmount).toFixed(2)
								: null,
							RegularCollectionAmount: parseFloat(this.regularAmount).toFixed(
								2
							),
							NextCollectionDue: moment.utc(this.nextCollectionDate).format(),
							EffectiveTo: this.effectiveTo
								? moment.utc(this.effectiveTo).format()
								: undefined,
						},
						{
							withCredentials: true,
						}
					)
					.then(async () => {
						this.$store.dispatch('getFixedPayments');
						this.submitStatus = 'OK';
						this.$snotify.success('Success! Direct debit set up.');
						document.getElementById('closeAddFixedPayment').click();
						this.regularAmount = null;
						this.initalAmount = null;
						this.firstCollection = null;
						this.effectiveTo = null;
						this.collectionDays = [];
					})
					.catch((error) => {
						// Error
						if (error.response) {
							// The request was made and the server responded with a status code
							// that falls out of the range of 2xx
							// this.submitStatus = 'Error'
							if (error.response.data.MoreInformation.length > 0) {
								error.response.data.MoreInformation.forEach((e) => {
									this.$snotify.error(`${e.Error}`, {
										timeout: 0,
										closeOnClick: true,
									});
								});
							} else {
								this.$snotify.error(`${error.response.data.UserDescription}`, {
									timeout: 0,
									closeOnClick: true,
								});
							}
						} else if (error.request) {
							// The request was made but no response was received
							// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
							// http.ClientRequest in node.js
							// this.submitStatus = 'Error'
							this.$snotify.error(`No response received.`, {
								timeout: 0,
								closeOnClick: true,
							});
						} else {
							// Something happened in setting up the request that triggered an Error
							// this.submitStatus = 'Error'
							this.$snotify.error(`${error.message}`, {
								timeout: 0,
								closeOnClick: true,
							});
						}
					});
			}
		},
		daysOfMonth() {
			var arr = Array(31);
			for (let index = 0; index < arr.length; index++) {
				arr[index] = index + 1;
			}
			return arr;
		},
		checkBacsCalendar() {
			if (this.firstCollection) {
				return this.$store.dispatch(
					'getBacsCalendar',
					moment.utc(this.firstCollection).format()
				);
			}
			return this.$store.commit('updateBacsCalendar', null);
		},
		scrollToEnd() {
			// scroll to the bottom of modal
			var element = this.$refs['#multiselect'];
			var top = element.offsetTop;
			window.scrollTo(0, top);
		},
	},
};
</script>
